module.exports = __webpack_public_path__ + "img/26.496ec205.jpg";